<template>
<div class="row" style="background-color: white;">
  <div class="Absolute-Center is-Responsive">
    <div id="logo-container"></div>
    <div style="font-size: 2em;">
      <p style="color: black;">Dental Place Medan</p>
    </div>
    <div class="col-sm-12">
      <div class="form-group col-md-12">
        <p>Congratulations !! You have just verify your email address.</p>
        <p>Use below button to Login.</p>
      </div>
      <button class="btn btn-primary btn-block" @click="login">Bring me back to Login!</button> 
    </div>  
  </div>    
</div>
</template>

<script>
import api from '../services/api'
import { MemberManagement } from '../models/memberManagement'
// import AppLookupField from '../../components/AppLookupField.vue'
// import AppDatatable from '../../components/AppDatatable.vue'
// import AppDatePicker from '../../components/AppDatePicker.vue'

export default {
//   components: {
//     AppLookupField, AppDatatable, AppDatePicker
//   },
  data() {
    return {
    //   rs: {
    //     ...requestSample,
    //     requestSampleDetail: []
    //   },
        // member: {
        //     ...member,
        // },
    }
  },
  async created() {
    if(this.$route.query.id !== undefined) {
        const approvedByEmailApi = api('member-management/approvalbymember')
        await approvedByEmailApi.update({}, this.$route.query.id)
    }
  },
  methods: {
    login() {
      this.$router.push({ name: 'login' })
    }
  }
}
</script>